<template>
  <div class="w-full max-w-7xl mx-auto px-[4vw] pb-12">
    <Head>
      <Title>{{ $t('city.start.meta.title', { prefixedCity: prefixedCity }) }}</Title>
      <Meta name="description" :content="$t('city.start.meta.description', { prefixedCity: prefixedCity })" />
    </Head>
    <div class="lg:mt-8 flex flex-col gap-8 md:gap-10">
      <!--
      <div class="debug" v-html="data.posts?.promoted?.map(post => [post.title, post.tags?.map(tag => tag.slug).join(', ')]?.join('\n')).join('\n\n')" />
      <div class="debug" v-html="data.posts?.cornerstone?.map(post => [post.title, post.tags?.map(tag => tag.slug).join(', ')]?.join('\n')).join('\n\n')" />
      <div class="debug" v-html="data.posts?.articles?.map(post => [post.title, post.tags?.map(tag => tag.slug).join(', ')]?.join('\n')).join('\n\n')" /> -->
      <!-- <div class="debug">{{ data }}</div> -->
      <CityHero />
      <CityPromoted :posts="data.posts?.promoted" />
      <CityArticles :posts="data.posts?.articles?.slice(0, 4)" />
      <!-- <CityFat /> -->
      <ClientOnly>
        <CityOffers />
      </ClientOnly>
      <ClientOnly>
        <CityEvents />
      </ClientOnly>
      <CityRestaurants />
      <CityCornerstone :posts="data.posts?.cornerstone" />
    </div>
  </div>
</template>

<script setup>
const fat = useFatStore()
const prefixedCity = usePrefixedCityName(fat.city?.name)

// Fetch start
const { data } = await useFetch(`/start`, { 
  key: `start-${fat.city?.slug}`,
  baseURL: useEnv('cmsBase'),
  query: {
    citySlug: computed(() => fat.city?.slug),
  }
})
</script>